import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { UsersIcon, MessageSquareIcon, HeartIcon, MessageCircleIcon } from 'lucide-react';
export const CommunityPage = () => {
  const [scrolled, setScrolled] = useState(false);
  // Mock community discussions
  const discussions = [{
    id: 1,
    title: "What's your favorite design tool for creating UI kits?",
    author: 'Sarah Johnson',
    authorAvatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    date: '2 days ago',
    replies: 24,
    likes: 18,
    category: 'Design'
  }, {
    id: 2,
    title: 'Tips for pricing digital products effectively',
    author: 'Michael Chen',
    authorAvatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '1 week ago',
    replies: 36,
    likes: 42,
    category: 'Business'
  }, {
    id: 3,
    title: 'How do you market your templates after publishing?',
    author: 'Emily Rodriguez',
    authorAvatar: 'https://randomuser.me/api/portraits/women/28.jpg',
    date: '3 days ago',
    replies: 19,
    likes: 15,
    category: 'Marketing'
  }, {
    id: 4,
    title: 'Looking for feedback on my new icon pack',
    author: 'David Wilson',
    authorAvatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    date: '5 days ago',
    replies: 12,
    likes: 8,
    category: 'Feedback'
  }, {
    id: 5,
    title: 'Best practices for documenting your digital products',
    author: 'Sophia Lee',
    authorAvatar: 'https://randomuser.me/api/portraits/women/56.jpg',
    date: '1 day ago',
    replies: 7,
    likes: 11,
    category: 'Resources'
  }];
  // Mock community members
  const members = [{
    id: 1,
    name: 'Sarah Johnson',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    role: 'UI Designer',
    contributions: 124
  }, {
    id: 2,
    name: 'Michael Chen',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    role: 'Product Creator',
    contributions: 98
  }, {
    id: 3,
    name: 'Emily Rodriguez',
    avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
    role: 'Marketing Specialist',
    contributions: 86
  }, {
    id: 4,
    name: 'David Wilson',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    role: 'Icon Designer',
    contributions: 67
  }];
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-5097">
      <Navbar scrolled={scrolled} data-id="element-5098" />
      <main className="pt-24 pb-20" data-id="element-5099">
        <div className="container mx-auto px-4 md:px-6" data-id="element-5100">
          <div className="max-w-6xl mx-auto" data-id="element-5101">
            {/* Header */}
            <div className="text-center mb-12" data-id="element-5102">
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-5103">
                Community
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto" data-id="element-5104">
                Join our community of creators, share ideas, get feedback, and
                connect with like-minded professionals
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-5105">
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-5106">
                <UsersIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-5107" />
                <h3 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-5108">
                  5,200+
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-5109">
                  Community Members
                </p>
              </div>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-5110">
                <MessageSquareIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-5111" />
                <h3 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-5112">
                  12,400+
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-5113">
                  Discussion Threads
                </p>
              </div>
              <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm text-center" data-id="element-5114">
                <HeartIcon className="h-10 w-10 mx-auto text-[#2DB489] dark:text-[#4ED1A0] mb-3" data-id="element-5115" />
                <h3 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-1" data-id="element-5116">
                  98%
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-5117">
                  Positive Interactions
                </p>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-8" data-id="element-5118">
              {/* Recent Discussions */}
              <div className="lg:w-2/3" data-id="element-5119">
                <div className="flex justify-between items-center mb-6" data-id="element-5120">
                  <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9]" data-id="element-5121">
                    Recent Discussions
                  </h2>
                  <button className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-white px-4 py-2 rounded-lg text-sm font-medium hover:shadow-lg transition-all" data-id="element-5122">
                    New Discussion
                  </button>
                </div>
                <div className="space-y-4" data-id="element-5123">
                  {discussions.map(discussion => <div key={discussion.id} className="bg-white dark:bg-[#162825] rounded-xl p-5 shadow-sm hover:shadow-md transition-all" data-id="element-5124">
                      <div className="flex items-start" data-id="element-5125">
                        <img src={discussion.authorAvatar} alt={discussion.author} className="w-10 h-10 rounded-full mr-4" data-id="element-5126" />
                        <div className="flex-1" data-id="element-5127">
                          <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-1 hover:text-[#2DB489] dark:hover:text-[#4ED1A0] cursor-pointer" data-id="element-5128">
                            {discussion.title}
                          </h3>
                          <div className="flex flex-wrap items-center text-sm text-gray-500 dark:text-[#7A8F8A] mb-3" data-id="element-5129">
                            <span data-id="element-5130">{discussion.author}</span>
                            <span className="mx-2" data-id="element-5131">•</span>
                            <span data-id="element-5132">{discussion.date}</span>
                            <span className="mx-2" data-id="element-5133">•</span>
                            <span className="bg-gray-100 dark:bg-[#1A3330] px-2 py-0.5 rounded-full text-xs" data-id="element-5134">
                              {discussion.category}
                            </span>
                          </div>
                          <div className="flex items-center space-x-4" data-id="element-5135">
                            <div className="flex items-center text-gray-500 dark:text-[#7A8F8A] text-sm" data-id="element-5136">
                              <MessageCircleIcon className="h-4 w-4 mr-1" data-id="element-5137" />
                              <span data-id="element-5138">{discussion.replies} replies</span>
                            </div>
                            <div className="flex items-center text-gray-500 dark:text-[#7A8F8A] text-sm" data-id="element-5139">
                              <HeartIcon className="h-4 w-4 mr-1" data-id="element-5140" />
                              <span data-id="element-5141">{discussion.likes} likes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="mt-6 text-center" data-id="element-5142">
                  <button className="bg-white dark:bg-[#162825] border border-gray-200 dark:border-[#1A3330] text-gray-700 dark:text-[#B0C1BD] px-6 py-3 rounded-lg font-medium hover:bg-gray-50 dark:hover:bg-[#1A3330] transition-colors" data-id="element-5143">
                    View All Discussions
                  </button>
                </div>
              </div>

              {/* Sidebar */}
              <div className="lg:w-1/3" data-id="element-5144">
                {/* Active Members */}
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm mb-6" data-id="element-5145">
                  <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5146">
                    Active Members
                  </h2>
                  <div className="space-y-4" data-id="element-5147">
                    {members.map(member => <div key={member.id} className="flex items-center" data-id="element-5148">
                        <img src={member.avatar} alt={member.name} className="w-10 h-10 rounded-full mr-3" data-id="element-5149" />
                        <div data-id="element-5150">
                          <h3 className="font-medium text-gray-800 dark:text-[#F8FAF9]" data-id="element-5151">
                            {member.name}
                          </h3>
                          <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-5152">
                            {member.role} • {member.contributions} contributions
                          </p>
                        </div>
                      </div>)}
                  </div>
                  <div className="mt-4 text-center" data-id="element-5153">
                    <button className="text-[#2DB489] dark:text-[#4ED1A0] text-sm hover:underline" data-id="element-5154">
                      View All Members
                    </button>
                  </div>
                </div>

                {/* Categories */}
                <div className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm mb-6" data-id="element-5155">
                  <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-5156">
                    Categories
                  </h2>
                  <div className="space-y-2" data-id="element-5157">
                    {['Design', 'Business', 'Marketing', 'Feedback', 'Resources', 'Technical', 'General'].map(category => <button key={category} className="block w-full text-left px-3 py-2 rounded-lg hover:bg-gray-50 dark:hover:bg-[#1A3330] text-gray-700 dark:text-[#B0C1BD] transition-colors" data-id="element-5158">
                        {category}
                      </button>)}
                  </div>
                </div>

                {/* Join Community */}
                <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-6 text-white" data-id="element-5159">
                  <h2 className="text-xl font-bold mb-3" data-id="element-5160">Join Our Community</h2>
                  <p className="mb-4 opacity-90" data-id="element-5161">
                    Connect with creators, get feedback, and share your
                    knowledge.
                  </p>
                  <button className="w-full bg-white text-[#0A3C52] px-4 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-5162">
                    Sign Up Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5163" />
    </div>;
};